export default "/images/hexagon-yellow.png?0557857c457104914b6bf360ff4e3112";